export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'quality',
    name: '品质保障',
    slug: 'quality',
    description: '久久久久始终坚持极致的品质标准，从源头把控每一个环节，确保为您呈现经得起时间考验的卓越产品。我们相信，真正的品质不是口号，而是融入血液的坚守。',
    icon: 'ri-shield-check-line',
    articleCount: 8,
  },
  {
    id: 'service',
    name: '长效服务',
    slug: 'service',
    description: '服务不止于交付的那一刻。久久久久提供覆盖产品全生命周期的长效服务，从专业咨询到售后保障，我们始终在您身边，让信赖延续每一天。',
    icon: 'ri-customer-service-2-line',
    articleCount: 6,
  },
  {
    id: 'performance',
    name: '稳定性能',
    slug: 'performance',
    description: '稳定性是久久久久的基因。通过严苛的测试体系和持续优化机制，我们确保产品在各种环境下都能保持卓越表现，让您安心无忧。',
    icon: 'ri-flashlight-line',
    articleCount: 7,
  },
  {
    id: 'durability',
    name: '耐久方案',
    slug: 'durability',
    description: '为长远而设计。久久久久的耐久解决方案融合先进材料科学与工程智慧，针对不同场景提供定制化的长效应对策略，让投入物超所值。',
    icon: 'ri-tools-line',
    articleCount: 5,
  },
];